import { defineStore, storeToRefs } from 'pinia';
import { useAccount } from '@/store/account';
import kpqxglApi from '@/api/sub-invoice/jcsz/kpqxgl';
import { getDetail } from '@/api/group/kpgl/kpsz/kpqxgl';
import { dayjs } from 'element-plus';

export const useInvoiceAuth = defineStore('auth', {
	state: () => ({
		// 开具普通发票标识 Y N
		kjptfpbz: '',
		// 可开具特定业务类型
		tdywdm: null,
		// tdywdmArr: [],
		// 可开具发票类型代码
		fplxdm: null,
		// fplxdmArr: [],
		// 是否允许当月红冲 0 1
		sfyxdyhc: undefined,
		// 是否允许跨月红冲 0 1
		sfyxkyhc: undefined,
		// 单张开票限额
		dzxe: undefined,
		// 月累计开票限额
		ydxe: undefined,
	}),
	getters: {
		tdywdmArr: (state) => (state.tdywdm ? (state.tdywdm as string).split(',') : []),
		fplxdmArr: (state) => (state.fplxdm ? (state.fplxdm as string).split(',') : []),
	},
	actions: {
		async getAuth(type: string = 'common', id?: string) {
			const storeAccount = useAccount();
			const { account, companiesId } = storeToRefs(storeAccount);
			const { id: userId } = account!.value as any;
			const qyId = companiesId!.value;
			let res;
			if (type === 'saas') {
				res = await getDetail({ userId, qyIdList: [id], manageType: 0 });
			} else {
				res = await kpqxglApi.getKpqxDetail({ userId, qyId });
			}
			const { kjptfpbz, tdywdm, fplxdm, sfyxdyhc, sfyxkyhc, dzxe, ydxe } = res.data[0] || {};
			this.kjptfpbz = kjptfpbz;
			this.tdywdm = tdywdm;
			this.fplxdm = fplxdm;
			// this.tdywdmArr = tdywdm ? tdywdm.split(',') : [];
			// this.fplxdmArr = fplxdm ? fplxdm.split(',') : [];
			this.sfyxdyhc = sfyxdyhc;
			this.sfyxkyhc = sfyxkyhc;
			this.dzxe = dzxe;
			this.ydxe = ydxe;
		},
		// 判断红冲操作权限判定
		checkRedRushAuth(date: string | number) {
			const nowDate = dayjs();
			const kpDate = dayjs(date);
			return new Promise((resolve, reject) => {
				if (!kpDate.isValid()) {
					return reject('未查询到蓝字发票开票日期');
				}
				if (kpDate.isSame(nowDate, 'month') && this.sfyxdyhc == 0) {
					return reject('当前用户无"当月红冲"权限');
				}
				if (kpDate.isBefore(nowDate, 'month') && this.sfyxkyhc == 0) {
					return reject('当前用户无"跨月红冲"权限');
				}
				resolve(true);
			});
		},
		// 判断是否支持特定业务
		checkTdywSupport(type: string | undefined) {
			if (type === undefined) return !!this.tdywdm || this.kjptfpbz !== 'N';
			if (!this.tdywdm && !this.kjptfpbz) return true; // 没有配置，默认支持
			if ((!type || type === '00') && this.kjptfpbz !== 'N') return true; //普通业务支持
			return this.tdywdmArr.includes(type as string);
		},
		// 判断是否支持发票类型
		checkFplxSupport(type: string | undefined) {
			if (type === undefined) return true;
			if (!this.fplxdm) return true; // 没有配置，默认支持
			return this.fplxdmArr.includes(type);
		},
		// 综合判断开票权限
		checkAuthSupport(tdywdm: string, fplxdm: string) {
			return new Promise((resolve, reject) => {
				if (!this.checkFplxSupport(fplxdm))
					return reject(
						`当前用户未授权${fplxdm === undefined ? '任何' : '该'}发票类型，如有疑问可联系管理员进行确认/修改`
					);
				if (!this.checkTdywSupport(tdywdm))
					return reject(
						`当前用户未授权${tdywdm === undefined ? '任何' : '该'}特定业务类型，如有疑问可联系管理员进行确认/修改`
					);
				resolve(true);
			});
		},
	},
});

const invoiceAuth = useInvoiceAuth();

export const checkRedRushAuth = invoiceAuth.checkRedRushAuth;

export const checkAuthSupport = invoiceAuth.checkAuthSupport;

export default invoiceAuth;
